const state = {
  loading: false,
  totalPages: 0,
  totalElmts: 0,
  currentWorkflow: {},
  signWorkflows: [],
  signTemplates: [],
  creationState: false,
};
export default state;



// WEBPACK FOOTER //
// ./src/store/modules/signWorkflow/state.js